import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { previewContinuousNumbering } from "../api/periodicalCheckService";
export var CONTINUOUS_NUMBERING_PREVIEW_KEY = "continuousNumberingPreview";
export var useContinuousNumberingPreview = function (titleId, request, _a) {
    var onSuccess = _a.onSuccess, onError = _a.onError;
    var kyInstance = useOkapiKy();
    return useQuery([CONTINUOUS_NUMBERING_PREVIEW_KEY, titleId, request], function () {
        return previewContinuousNumbering(kyInstance, titleId, request);
    }, {
        enabled: request !== null,
        keepPreviousData: true,
        retry: false,
        staleTime: 0,
        cacheTime: 0,
        onSuccess: onSuccess,
        onError: onError,
    });
};
